import Storage from "../localStorage";
import Notify from "./notify";
import Metis from "../metis";
import {escapeMetisVariables, unescapeMetisReturnObject} from "./escapeMetis";

const metis = new Metis();
const notify = new Notify();
const storage = new Storage();

const wp = wp_metis;

const cartFields = `
  warenkorbKey
  warenkorbKurse {
    warenkorbKursKey
    kurs {
      kursnr
      kursbez
      preis
      preisRabatt
      kursOnline {
        onlineBezeichnung
      }
      produkt {
        produktnr
      }
      anfang
      ende
    }
    anzahl
    originalpreis
    einzelpreis
    gesamtpreis
    warteliste
    gutscheine {
      gutschein {
        betrag
        bezeichnung
        warenkorb
        kombinierbar
        prozent
        maxbetrag
      }
      minBetrag
      betrag
    }
    guthaben {
      guthaben {
        bezeichnung
        betrag
      }
      minBetrag
      betrag
    }
    fruehbucherRabattAktiv
  }
  bundles {
    warenkorbBundleKey
    warenkorbBundleKurse {
      warenkorbBundleKursKey
      bundleKonfigurationKurs {
        kurs {
          kursnr
          kursbez
          preis
          preisRabatt
          kursOnline {
            onlineBezeichnung
          }
          produkt {
            produktnr
          }
          anfang
          ende
        }
      }
      originalpreis
      einzelpreis
      guthaben {
        guthaben {
          bezeichnung
          betrag
        }
        minBetrag
        betrag
      }
    }
    bundleKonfiguration {
      bundleKonfigurationKey
      bundleOberkategorie {
        id
        bezeichnung
        zeitraum
      }
      bundleKonfigurationUnterkategorien {
        bundleUnterkategorie {
          id
        }
        bundleKonfigurationKurse {
          kurs {
            kursnr
          }
        }
        valide
      }
      verwendeteCredits
      maxCredits
      valide
      createTime
    }
    originalpreis
    einzelpreis
    gesamtpreis
    anzahl
  }
  gesamtpreis
  guthabenBetrag
  gutscheinBetrag
  gutscheine {
    gutschein {
      betrag
      bezeichnung
      warenkorb
      kombinierbar
      prozent
      maxbetrag
    }
  }
  guthaben {
    guthaben {
      bezeichnung
      betrag
    }
  }
`;

class ShoppingCart {
  /**
   * Get warenkorb by warenkorbKey
   *
   * @param {string} warenkorbKey
   * @returns

   */
  async getShoppingCart(warenkorbKey) {
    const request = metis.metisRequest({
      query: `
        query{
          getWarenkorb(warenkorbKey: "${warenkorbKey}"){
            ${cartFields}
          }
      }`,
    });

    const response = await request;

    if (response) {
      return response.getWarenkorb;
    }
  }

  /**
   * Get warenkorb by warenkorbKey
   *
   * @param {string} warenkorbKey
   * @returns

   */
   async getShoppingCartCourses(warenkorbKey) {
    const request = metis.metisRequest({
      query: `
        query{
          getWarenkorb(warenkorbKey: "${warenkorbKey}"){
            warenkorbKey
            warenkorbKurse {
              warenkorbKursKey
            }
          }
      }`,
    });

    const response = await request;

    if (response) {
      return response.getWarenkorb;
    }
  }

  async getWarenkorb() {
    const localKey = storage.getWarenkorbKey();
    const isLoggedIn = await metis.isLoggedIn();
    const userWarenkorb = isLoggedIn ? await this.getCurrentUserCart() : null;

    if (localKey) {
      if (isLoggedIn && userWarenkorb) {
        if (localKey !== userWarenkorb.warenkorbKey) {
          const guestWarenkorb = await this.getUnassigedCart(localKey);
          this.assignCartToUser(guestWarenkorb.warenkorbKey);
          return guestWarenkorb;
        } else {
          return userWarenkorb;
        }
      } else {
        const guestWarenkorb = await this.getUnassigedCart(localKey);
        const response = await guestWarenkorb;

        if (response) {
          return response;
        }
      }
    }

    return null;
  }

  async getCurrentUserCart() {
    const request = metis.metisRequest({
      query: `
          query {
            getUserWarenkorb {
                warenkorbKey
              }
          }`,
    });

    const response = await request;

    if (response) {
      if (response?.getUserWarenkorb?.warenkorbKey) {
        return response.getUserWarenkorb.warenkorbKey;
      }
    }
  }

  async getUserCartFromMetis() {
    const request = metis.metisRequest({
      query: `
        query {
            getUserWarenkorb {
                warenkorbKey
            }
        }`,
    });

    const response = await request;
    if (response?.getUserWarenkorb?.warenkorbKey) {
      return response.getUserWarenkorb.warenkorbKey;
    }
  }

  async getUnassigedCart(warenkorbKey) {
    // console.log(warenkorbKey);
    const request = metis.metisRequest({
      query: `query{
            getWarenkorb(warenkorbKey: "${warenkorbKey}"){
              ${cartFields}
            }
          }

          `,
    });

    const response = await request;
    if (response) {
      return response.getWarenkorb;
    }
  }

  async addCourseToCart(warenkorbKey, kursnr, anzahl = 1) {
    const addToCart = metis.metisRequest({
      query: `
        mutation{
            addKursToWarenkorb(mandantennummer: ${wp.mandantennummer}, warenkorbKey: "${warenkorbKey}", kursnr: "${kursnr}", anzahl: ${anzahl}){
              warenkorbKey
            }
        }`,
    }, true, true);

    const response = await addToCart;

    if (response) {
      if(response?.[0]?.extensions?.errorMessage && response[0].extensions.errorMessage.endsWith('existiert nicht.')) { // faulty key, remove from localstorage
        storage.removeWarenkorbKey();
      } else {
        notify.emit([
          {
            message: "Der Kurs wurde in den Warenkorb gelegt",
            status: "success",
          },
        ]);
        return response.addKursToWarenkorb;
      }
    }
  }

  async createCart(kursnr, anzahl = 1) {
    const request = metis.metisRequest({
      query: `
          mutation {
            addKursAndCreateWarenkorb(mandantennummer:${wp.mandantennummer}, kursnr: "${kursnr}", anzahl: ${anzahl}) {
              warenkorbKey
            }
        }`,
    });

    const response = await request;

    if (response) {
      notify.emit([
        {
          message: "Der Kurs wurde in den Warenkorb gelegt",
          status: "success",
        },
      ]);
      return response.addKursAndCreateWarenkorb;
    }
  }

  async removeCourseFromCart(warenkorbKursKey) {
    const removeCourse = metis.metisRequest({
      query: `
        mutation {
           deleteWarenkorbKurs(warenkorbKursKey: "${warenkorbKursKey}") {
             ${cartFields}
            }
        }`,
    });

    const response = await removeCourse;

    if (response) {
      return response.deleteWarenkorbKurs;
    }
  }

  async changeCourseQuantity(warenkorbKursKey, anzahl) {
    const request = metis.metisRequest({
      query: `
        mutation {
            changeQuantityOfWarenkorbKurs(warenkorbKursKey: "${warenkorbKursKey}", anzahl: ${anzahl}) {
              ${cartFields}
            }
        }`,
    });

    const response = await request;

    if (response) {
      return response.changeQuantityOfWarenkorbKurs;
    }
  }

  async assignCartToUser(warenkorbKey) {
    metis.metisRequest({
      query: `
        mutation {
            assignWarenkorbToUser(warenkorbKey: "${warenkorbKey}")
        }`,
    });
  }

  async addGutscheinToWarenkorb(warenkorbKey, gutscheinBezeichnung) {
    [gutscheinBezeichnung] = escapeMetisVariables(gutscheinBezeichnung);
    const request = metis.metisRequest({
      query: `
        mutation {
          addGutscheinToWarenkorb(warenkorbKey: "${warenkorbKey}" gutscheinBezeichnung: "${gutscheinBezeichnung}") {
            ${cartFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.addGutscheinToWarenkorb;
    }
  }


  async deleteGutscheinFromWarenkorb(warenkorbKey, gutscheinBezeichnung) {
    [gutscheinBezeichnung] = escapeMetisVariables(gutscheinBezeichnung);
    const request = metis.metisRequest({
      query: `
        mutation {
          deleteGutscheinFromWarenkorb(warenkorbKey: "${warenkorbKey}" gutscheinBezeichnung: "${gutscheinBezeichnung}") {
            ${cartFields}
          }
        }`,
    });

    const response = await request;

    console.log(warenkorbKey, response);

    if (response) {
      return response.deleteGutscheinFromWarenkorb;
    }
  }

  async addGuthabenToWarenkorb(warenkorbKey, guthabenBezeichnung) {
    [guthabenBezeichnung] = escapeMetisVariables(guthabenBezeichnung);
    const request = metis.metisRequest({
      query: `
        mutation {
          addGuthabenToWarenkorb(warenkorbKey: "${warenkorbKey}" guthabenBezeichnung: "${guthabenBezeichnung}") {
            ${cartFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.addGuthabenToWarenkorb;
    }
  }

  async deleteGuthabenFromWarenkorb(warenkorbKey, guthabenBezeichnung) {
    [guthabenBezeichnung] = escapeMetisVariables(guthabenBezeichnung);
    const request = metis.metisRequest({
      query: `
        mutation {
          deleteGuthabenFromWarenkorb(warenkorbKey: "${warenkorbKey}"  guthabenBezeichnung: "${guthabenBezeichnung}") {
            ${cartFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.deleteGuthabenFromWarenkorb;
    }
  }

  async getUserGuthabenInformationen() {
    const request = metis.metisRequest({
      query: `
        query {
          getUserGuthabenInformationen {
            guthaben {
              bezeichnung
              betrag
            }
            wirdImWarenkorbAngewandt
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.getUserGuthabenInformationen;
    }
  }

  async addBundleAndCreateWarenkorb(bundleKonfigurationKey) {
    const request = metis.metisRequest({
      query: `
        mutation {
          addBundleAndCreateWarenkorb (
            mandantennummer: ${wp.mandantennummer}
            bundleKonfigurationKey: "${bundleKonfigurationKey}"
            anzahl: 1
          ) {
            ${cartFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      notify.emit([
        {
          message: "Das Bundle wurde in den Warenkorb gelegt",
          status: "success",
        },
      ]);
      return response.addBundleAndCreateWarenkorb;
    }
  }

  async addBundleToWarenkorb(warenkorbKey, bundleKonfigurationKey) {
    const request = metis.metisRequest({
      query: `
        mutation {
          addBundleToWarenkorb (
            warenkorbKey: "${warenkorbKey}"
            bundleKonfigurationKey: "${bundleKonfigurationKey}"
            anzahl: 1
          ) {
            ${cartFields}
          }
        }`,
    }, true, true);

    const response = await request;

    if (response) {
      if(response?.[0]?.extensions?.errorMessage && response[0].extensions.errorMessage.endsWith('existiert nicht.')) { // faulty key, remove from localstorage
        storage.removeWarenkorbKey();
      } else {
        notify.emit([
          {
            message: "Das Bundle wurde in den Warenkorb gelegt",
            status: "success",
          },
        ]);
        return response.addBundleToWarenkorb;
      }
    }
  }

  async deleteBundleFromWarenkorb(warenkorbBundleKey) {
    const request = metis.metisRequest({
      query: `
        mutation {
          deleteBundleFromWarenkorb(warenkorbBundleKey: "${warenkorbBundleKey}") {
            ${cartFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.deleteBundleFromWarenkorb;
    }
  }
}

export default ShoppingCart;

